module.exports = __webpack_public_path__ + "static/media/green-chameleon-s9CC2SKySJM-unsplash.0e651ff6.jpg";